import { render, staticRenderFns } from "./TransferKilo.vue?vue&type=template&id=fcf2e0f0"
import script from "./TransferKilo.vue?vue&type=script&lang=js"
export * from "./TransferKilo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports